/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wf_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text is split on spaces and punctuation, so 'cat,' and 'cat' count as the same word. Matching is case-insensitive by default.`)
};

const es_wf_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El texto se divide en espacios y puntuación, así que "cat," y "cat" cuentan como la misma palabra. La búsqueda es sin distinción de mayúsculas por defecto.`)
};

const de_wf_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Text wird anhand von Leerzeichen und Satzzeichen aufgeteilt, sodass 'cat,' und 'cat' als dasselbe Wort gezählt werden. Die Groß-/Kleinschreibung wird standardmäßig ignoriert.`)
};

const nl_wf_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekst wordt op spaties en interpunctie gesplitst, dus 'cat,' en 'cat' tellen als hetzelfde woord. Matching is standaard onafhankelijk van hoofletter.`)
};

const fr_wf_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le texte est divisé sur les espaces et la ponctuation, donc "cat," et "cat" comptent comme le même mot. L'appariement est insensible à la casse par défaut.`)
};

const it_wf_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il testo viene suddiviso su spazi e punteggiatura, quindi 'cat,' e 'cat' contano come la stessa parola. La corrispondenza è senza distinzione maiuscole/minuscole per impostazione predefinita.`)
};

const pt_br2_wf_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O texto é dividido em espaços e pontuação, então 'cat,' e 'cat' contam como a mesma palavra. A correspondência é sem diferenciação entre maiúsculas e minúsculas por padrão.`)
};

const pt_wf_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O texto é dividido em espaços e pontuação, então 'cat,' e 'cat' contam como a mesma palavra. A correspondência é sem diferença de maiúsculas/minúsculas por padrão.`)
};

const ja_wf_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストはスペースと句読点で分割されるため、「cat,」と「cat」は同じ単語としてカウントされます。マッチングはデフォルトでは大文字小文字を区別しません。`)
};

const zh_wf_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文本会按空格和标点符号进行拆分，因此“cat,”和“cat”会被视为同一个单词。默认情况下匹配不区分大小写。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wf_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wf_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wf_faq2_a", locale)
	if (locale === "en") return en_wf_faq2_a(inputs)
	if (locale === "es") return es_wf_faq2_a(inputs)
	if (locale === "de") return de_wf_faq2_a(inputs)
	if (locale === "nl") return nl_wf_faq2_a(inputs)
	if (locale === "fr") return fr_wf_faq2_a(inputs)
	if (locale === "it") return it_wf_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_wf_faq2_a(inputs)
	if (locale === "pt") return pt_wf_faq2_a(inputs)
	if (locale === "ja") return ja_wf_faq2_a(inputs)
	return zh_wf_faq2_a(inputs)
};